import React, { useState, useEffect } from "react";
import "./ComparisonTable.css";

const comparisonTableData = [
  {
    category: "비용 부담",
    self: "저자 부담",
    semi: "저자·출판사 분담",
    planned: "출판사 부담",
  },
  {
    category: "수익 정산",
    self: "종이책 - 정가의 50% ( 전자책 - 순수익의 60% )",
    semi: "계약 기준 분배",
    planned: "계약 기준 인세 지급",
  },
  { 
    category: "진행 방식", 
    self: "저자 주도 · 출판사 지원", 
    semi: "저자 · 출판사 협업", 
    planned: "출판사 주도" 
  },
  {
    category: "출판사 역할",
    self: "제작 · 유통 · 정산 지원",
    semi: "기획 · 제작 협업",
    planned: "전 과정 주도",
  },
  {
    category: "예상 비용",
    self: "100만 원 ~",
    semi: "협의 후 결정",
    planned: " 저자 제작비 부담 없음",
  },
];

const columnDetails = {
  self: { label: "자비 출판", className: "self" },
  semi: { label: "반기획 출판", className: "semi" },
  planned: { label: "기획 출판", className: "planned" },
};

const ComparisonTable = ({ highlightedColumn }) => {
  const [activeColumn, setActiveColumn] = useState("self");

  useEffect(() => {
    // Sync with prop from parent, or default to 'self'
    setActiveColumn(highlightedColumn || "self");
  }, [highlightedColumn]);

  return (
    <div className="comparison-table-wrapper">
      {/* DESKTOP TABLE */}
      <div className="comparison-table-desktop">
        <div className="table-row header-row">
          <div className="table-cell category-header"></div>
          <div
            className={`table-cell table-header self ${
              highlightedColumn === "self" ? "highlighted" : ""
            }`}
          >
            자비 출판
          </div>
          <div
            className={`table-cell table-header semi ${
              highlightedColumn === "semi" ? "highlighted" : ""
            }`}
          >
            반기획 출판
          </div>
          <div
            className={`table-cell table-header planned ${
              highlightedColumn === "planned" ? "highlighted" : ""
            }`}
          >
            기획 출판
          </div>
        </div>
        {comparisonTableData.map((row, index) => (
          <div key={index} className="table-row">
            <div className="table-cell category-cell">{row.category}</div>
            <div
              className={`table-cell ${
                highlightedColumn === "self" ? "highlighted" : ""
              }`}
            >
              {row.self}
            </div>
            <div
              className={`table-cell ${
                highlightedColumn === "semi" ? "highlighted" : ""
              }`}
            >
              {row.semi}
            </div>
            <div
              className={`table-cell ${
                highlightedColumn === "planned" ? "highlighted" : ""
              }`}
            >
              {row.planned}
            </div>
          </div>
        ))}
      </div>

      {/* MOBILE/TABLET VIEW */}
      <div className="comparison-table-mobile">
        <div className="mobile-tabs">
          {Object.keys(columnDetails).map((key) => (
            <button
              key={key}
              onClick={() => setActiveColumn(key)}
              className={`mobile-tab-button ${columnDetails[key].className} ${
                activeColumn === key ? "active" : ""
              }`}
            >
              {columnDetails[key].label}
            </button>
          ))}
        </div>

        <div className="mobile-content">
          {comparisonTableData.map((row, index) => (
            <div key={index} className="mobile-row">
              <div className="mobile-cell category-cell">{row.category}</div>
              <div className="mobile-cell value-cell">{row[activeColumn]}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ComparisonTable;
